import axios from 'axios';
import { getRuntimeConfig, applyAuthHeaders, effectiveBaseUrl } from '@vft/config/runtimeConfig.js';

const sherpaClient = axios.create({
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

sherpaClient.interceptors.request.use((config) => {
  const cfg = getRuntimeConfig();
  config.baseURL = effectiveBaseUrl(cfg);
  config.headers = config.headers || {};
  // NOMÉS Authorization (com vue-dashboard/src/services/api.js). El header HTTP
  // `version` provocava un preflight CORS que el backend rebutja (Access-Control-
  // Allow-Headers no l'inclou); la versió ja viatja al requestHeader del cos.
  applyAuthHeaders(config.headers, cfg);
  return config;
});

export default sherpaClient;
